import React from 'react'
import TextField from '../../../../core/common/textFields/TextField'
import Select, { StylesConfig } from "react-select";
import { DatePicker } from 'antd';
import dayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

const DetailsPromoteLead = ({ formik, getallActiveUsers,projectRecordNumber }: any) => {

    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };
    dayjs.extend(customParseFormat);

    const handleSaleDateChange = (date: Dayjs | null) => {
        formik.setFieldValue('promoteDetails.leadSaleDate', date ? date.format('YYYY-MM-DD') : null);
    };
    const handleSaleAcceptedDateChange = (date: Dayjs | null) => {
        formik.setFieldValue('promoteDetails.leadSaleAcceptedDate', date ? date.format('YYYY-MM-DD') : null);
    };
    const handleJobCmpDateChange = (date: Dayjs | null) => {
        formik.setFieldValue('promoteDetails.jobCompleteDate', date ? date.format('YYYY-MM-DD') : null);
    };
    const handleWarrantyDateChange = (date: Dayjs | null) => {
        formik.setFieldValue('promoteDetails.warrantyEndDate', date ? date.format('YYYY-MM-DD') : null);
    };

    return (
        <div className='row'>
            <div className='col-md-12'>
                <h5 className='color-red'>Sales Information</h5>
            </div>
            <div className='col-md-6'>
                <TextField
                    label="Project Number"
                    type="text"
                    value={projectRecordNumber}
                    // required
                    disabled
                    // {...formik.getFieldProps('promoteDetails.projectNumber')}
                />
            </div>
            <div className="col-md-6">
                <label className="input-label">
                    Suprintendent
                </label>
                <Select
                    styles={customStyles}
                    className="select"
                    options={getallActiveUsers?.result?.map((option: any) => ({
                        label: option?.userName,
                        value: option?.userId
                    }))}
                    placeholder='Select'
                    value={
                        formik.values?.promoteDetails?.superintendent?.id
                            ? {
                                value: formik.values?.promoteDetails?.superintendent?.id,
                                label: formik.values?.promoteDetails?.superintendent?.value || '',
                            }
                            : null
                    }
                    onChange={(selectedOption: any) => {
                        formik.setFieldValue("promoteDetails.superintendent.value", selectedOption?.label)
                        formik.setFieldValue("promoteDetails.superintendent.id", selectedOption?.value)
                    }}
                />
            </div>
            <div className="col-md-6">
                <label className="input-label">
                    Sale Date 
                    {/* <span className="text-danger">*</span> */}
                </label>
                <div className="form-wrap icon-form">
                    <span className="form-icon">
                        <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                        className="form-control datetimepicker deals-details"
                        onChange={handleSaleDateChange}
                        value={formik.values?.promoteDetails?.leadSaleDate ? dayjs(formik.values.promoteDetails?.leadSaleDate, 'YYYY-MM-DD') : null}
                        format='MMM-DD-YYYY'
                    />
                </div>
            </div>
            <div className="col-md-6">
                <label className="input-label">
                    Sale Accepted Date
                </label>
                <div className="form-wrap icon-form">
                    <span className="form-icon">
                        <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                        className="form-control datetimepicker deals-details"
                        onChange={handleSaleAcceptedDateChange}
                        value={formik?.values?.promoteDetails?.leadSaleAcceptedDate ? dayjs(formik?.values?.promoteDetails?.leadSaleAcceptedDate, 'YYYY-MM-DD') : null}
                        format='MMM-DD-YYYY'

                    />
                </div>
            </div>
            <div className="col-md-6">
                <label className="input-label">
                    Job Complete Date
                     {/* <span className="text-danger">*</span> */}
                </label>
                <div className="form-wrap icon-form">
                    <span className="form-icon">
                        <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                        className="form-control datetimepicker deals-details"
                        onChange={handleJobCmpDateChange}
                        value={formik?.values?.promoteDetails?.jobCompleteDate ? dayjs(formik?.values.promoteDetails?.jobCompleteDate, 'YYYY-MM-DD') : null}
                        format='MMM-DD-YYYY'

                    />
                </div>
            </div>
            <div className="col-md-6">
                <label className="input-label">
                    Warranty End Date
                </label>
                <div className="form-wrap icon-form">
                    <span className="form-icon">
                        <i className="ti ti-calendar-check" />
                    </span>
                    <DatePicker
                        className="form-control datetimepicker deals-details"
                        onChange={handleWarrantyDateChange}
                        value={formik?.values?.promoteDetails?.warrantyEndDate ? dayjs(formik?.values.promoteDetails?.warrantyEndDate, 'YYYY-MM-DD') : null}
                        format='MMM-DD-YYYY'

                    />
                </div>
            </div>
        </div>
    )
}

export default DetailsPromoteLead